<section
  class="flex flex-col items-center pt-20 px-4 pb-14 mx-auto my-0 max-w-screen-lg"
>
  <app-section-header i18n-header header="FAQ" />

  <!-- <div class="flex !-mt-4 mb-4">
    <button mat-raised-button (click)="accordion().openAll()" class="mx-2" i18n>
      Expand All
    </button>
    <button
      mat-raised-button
      (click)="accordion().closeAll()"
      class="mx-2"
      i18n
    >
      Collapse All
    </button>
  </div> -->

  <mat-accordion multi>
    @for (item of faqEntries; track item.question) {
      <app-faq-entry [entry]="item"></app-faq-entry>
    }
  </mat-accordion>

  <div class="flex gap-4 mt-6">
    <a i18n-routerLink="@@//faq" routerLink="/faq" class="button text-sm">
      <mat-icon class="text-sm !w-auto !h-auto">open_in_new</mat-icon>
      <span i18n>Full FAQ</span>
    </a>

    <a
      i18n-routerLink="@@//contact-us"
      routerLink="/contact-us"
      class="button text-sm"
    >
      <mat-icon class="text-sm !w-auto !h-auto">open_in_new</mat-icon>
      <span i18n>Contact us</span>
    </a>
  </div>
</section>
